import React from 'react';
import { Layout } from '../../containers/layout';
import Meta from '../Meta';
import NotFoundImage from '../../../public/images/generic/404.svg';
import { captureError } from '../../modules/monitoring';
import {
  Container,
  ContentWrapper,
  Wrapper,
  StyledHeading,
  StyledText,
  StyledLinkButton,
} from './ErrorPage.styled';

interface ButtonProps {
  location: string;
  text: string;
}

interface ErrorPageProps {
  heading: string;
  body: string;
  button: ButtonProps;
  statusCode: number;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  heading,
  body,
  button,
  statusCode,
}) => {
  captureError(new Error('404'));

  return (
    <Layout>
      <Meta subtitle={statusCode.toString()} />
      <Container>
        <ContentWrapper>
          <Wrapper>
            <NotFoundImage />

            <StyledHeading as="h2" style="headingLarge" color="black">
              {heading}
            </StyledHeading>

            <StyledText style="bodyMedium" color="darkGrey">
              {body}
            </StyledText>

            <StyledLinkButton
              href={button.location}
              color="mediumBlue"
              variant="solid"
              size="medium"
            >
              {button.text}
            </StyledLinkButton>
          </Wrapper>
        </ContentWrapper>
      </Container>
    </Layout>
  );
};
